import styled from 'styled-components'
import BreakpointUp from '../Media/BreakpointUp'

export const Modal = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1050;
	width: 100%;
	height: 100%;
	overflow: hidden;
	outline: 0;
	display: ${props => props.hidden ? "none" : "block"};
`

Modal.defaultProps = {
}
export const CloseButton = styled.button`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
    right: 5px;
    top: 5px;
    width: 38px;
    height: 38px;

	background-color:#161420;
	cursor: pointer;
	z-index:1;	
	transition:all 0.5s ease-in-out;
	svg {
		width: 12px;
		height: 12px;
		fill: #fff;
	}
	&:hover {
		background-color:#161420;
		svg {
			fill:#fff;
		}
	}


`
CloseButton.defaultProps = {
}

export const ModalDialog = styled.div`
	position: relative;
	width: auto;
	pointer-events: none; 
`
ModalDialog.defaultProps = {
}

export const ModalContent = styled.div`
	background-color: ${props => props.bgColor};	
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	pointer-events: auto;
	background-clip: padding-box;
	outline: 0;
`
ModalContent.defaultProps = {
	bgColor: "#fff",
}

export const ModalHeader = styled.div`
	padding: 30px 20px 20px;
	${BreakpointUp.md`
		padding:30px;
	`}
	${BreakpointUp.lg`
		padding: 40px;
	`}
	+ .modal-body{
		padding-top:0;
	}
`
ModalHeader.defaultProps = {
}

export const ModalBody = styled.div`
	position: relative;
	flex: 1 1 auto;
	padding: 30px 20px 20px;
	${BreakpointUp.md`
		padding:30px;
	`}
	${BreakpointUp.lg`
		padding: 40px;
	`}
`
ModalBody.defaultProps = {
}


export const ModalTitle = styled.div`   
	font-weight: 600;
	text-align: ${props=>props.textAlign};
    color:${props=>props.color};
    margin-bottom: ${props=>props.mb};
    max-width: ${props=>props.maxWidth};
	width:100%;
    font-size: 20px;
    line-height: 30px;
    @media (min-width: 768px) {
        font-size: 22px;
        line-height: 32px;
    }
    @media (min-width: 992px) {
        font-size: 28px;
        line-height: 36px;
    }
    @media (min-width: 1600px) {
        font-size: 32px;
        line-height: 42px;
    }
`
ModalTitle.defaultProps = {
	textAlign:"left",
	color:"#373636",
	mb:"#0",
	maxWidth:"none",	
}

export const ModalSubTitle = styled.div`   
	font-weight: 500;
	text-align: ${props=>props.textAlign};
    color:${props=>props.color};
    margin-bottom: ${props=>props.mb};
    max-width: ${props=>props.maxWidth};
    width:100%;
    font-size: 14px;
    line-height: 24px;
    @media (min-width: 768px) {
        font-size: 16px;
        line-height: 28px;
    }
    @media (min-width: 992px) {
        font-size: 18px;
        line-height: 30px;
    }
`
ModalSubTitle.defaultProps = {
	textAlign:"left",
	color:"#373636",
	mb:"#0",
	maxWidth:"none",	
}

export const ModalFooter = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: flex-end;
	padding:15px;
`
ModalFooter.defaultProps = {
}

export const ModalBackdrop = styled.div`
	position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #161420;
	inset: 0px;
	opacity: .8;
	display: ${props => props.hidden ? "none" : "block"};
`